<template>
  <section id="reserve">
    <div class="reserve-content">
      <!-- タイトル・サブタイトル -->
      <div class="text-wrapper">
        <h1 class="title">{{ $t('page.reserve.title') }}</h1>
        <div class="sub-title">{{ $t('page.reserve.sub-title') }}</div>
      </div>

      <!-- 予約フォームへボタン -->
      <button class="button" @click="clickReservedForm">
        {{ $t('page.reserve.reserved-form') }}
      </button>
    </div>
  </section>
</template>
<script setup lang="ts">
import { actionExternalNewTabTransition, externalTransitionType } from "~/models/Utility";

const { locale } = useI18n()
const clickReservedForm = () => {
  const url = externalTransitionType.reserve[locale.value];
  actionExternalNewTabTransition(url);
}
</script>
<style lang="scss" scoped>
@use '@/assets/styles/variables' as v;
@use '@/assets/styles/mixins' as m;

#reserve {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: v.$bg-cover-color;
  transition: all 0.3s ease-out;
  height: 600px;
  @include m.sp() {
    background: rgba(238, 232, 225, 0.9);
    height: 311px;
    padding: 88px 0;
  }

  .reserve-content {
    @include m.sp() {
      max-width: 272px;
      width: 100%;
    }
  }

  .text-wrapper {

    .title {
      color: v.$text-white-color;
      font-size: 1.125rem;
      font-family: v.$accent-font-family;
      font-weight: v.$font-weight-light;
      margin: 0;
      @include m.sp() {
        color: v.$text-base-color;
        font-size: 1rem;
        letter-spacing: 6.4px;
      }
    }

    .sub-title {
      color: v.$text-white-color;
      font-size: 1.375rem;
      @include m.sp() {
        color: v.$text-base-color;
        font-size: 1.25rem;
        letter-spacing: 3px;
      }
    }
  }

  .button {
    position: relative;
    margin-top: 38px;
    color: v.$text-white-color;
    font-size: 1rem;
    width: 328px;
    height: 48px;
    border: 2px solid v.$bg-white-color;
    @include m.sp() {
      margin-top: 32px;
      color: v.$common-white-color;
      background: v.$accent-color;
      border: none;
      max-width: 272px;
      width: 100%;
      height: 48px;
    }

    /* 外枠のアニメーション用 */
    &::after {
      box-sizing: border-box;
      position: absolute;
      width: 324px;
      height: 44px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      content: '';
      opacity: 0;
      border: 4px solid v.$accent-color;
      @include m.sp() {
        display: none;
      }
    }
  }

  &:hover {
    background: rgba(255, 255, 255, 0.85);

    .title {
      color: v.$text-base-color;
    }

    .sub-title {
      color: v.$text-base-color;
    }

    .button {
      background: v.$accent-color;
      border: none;
      width: 324px;
      height: 44px;
      @include m.sp() {
        color: v.$common-white-color;
        background: v.$accent-color;
        border: none;
        max-width: 272px;
        width: 100%;
        height: 48px;
      }

      /* 外枠のアニメーション用 */
      &::after {
        opacity: 1;
        transition: all 0.3s ease-out;
        /* じわっとサイズが大きくなるアニメーション */
        transform: translate(-50%, -50%) scale(1.015, 1.08);

        @include m.sp() {
          display: none;
        }
      }
    }
  }
}
</style>
